module.exports = __webpack_public_path__ + "img/livepen2025_02.6153c077.jpg";